import React from 'react';
import { ISvgProps } from '../svg.types';

export const PersonalityReportChevaleresque = (props: ISvgProps) => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 138 122"
    {...props}
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1={19}
        y1={61}
        x2={119}
        y2={61}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.26} stopColor="#ffcdba" />
        <stop offset={1} stopColor="#ff9ba1" />
      </linearGradient>
      <linearGradient
        id="Dégradé_sans_nom_8"
        x1={66.56}
        y1={42.92}
        x2={73.87}
        y2={42.92}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#b71400" />
        <stop offset={1} stopColor="#f21f00" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1={40.25}
        y1={93.13}
        x2={68.5}
        y2={93.13}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#050504" />
        <stop offset={1} stopColor="#665e58" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        x1={24.46}
        y1={96.36}
        x2={51.51}
        y2={96.36}
        xlinkHref="#linear-gradient-2"
      />
      <style>
        {`.cls-3{fill:#e67d64}.cls-5{fill:#f6a18a}.cls-6{fill:#25140c}.cls-7{fill:#ffaa7d}.cls-8{fill:#a40600}.cls-9{fill:#002b34}.cls-10,.cls-12{fill:#b28b67;fill-rule:evenodd}.cls-12{fill:#e4e4e4}.cls-17{fill:#ff3e14}`}
      </style>
    </defs>
    <circle
      cx={69}
      cy={61}
      r={50}
      fill="url(#linear-gradient)"
      id="Calque_14"
      data-name="Calque 14"
    />
    <g id="Calque_12" data-name="Calque 12">
      <path
        d="M73.85 41.42a1.82 1.82 0 00-1.94-1.78 2.22 2.22 0 00-1.78 1.43 2.21 2.21 0 00-2.07-1 1.83 1.83 0 00-1.48 2.18c.26 2.27 4.12 4 4.12 4s3.41-2.55 3.15-4.83z"
        fill="url(#Dégradé_sans_nom_8)"
      />
      <g id="mom">
        <path
          className="cls-3"
          d="M88.88 56.15c-.32-1.34-1.48-1.54-1.52-1.39a28.62 28.62 0 01-1.62-2.65s0 3.64-.28 6.2a25 25 0 01-3.7 9.52c-.22.8.72.82 1.29 1.15.41-.3 3.26-2.94 5.2-9a.85.85 0 000-.17 22.57 22.57 0 00.63-3.66z"
        />
        <path
          d="M88.41 54.71s-3.31-2-3.48-2.19 1.27-4.64 4.95-5.6a6.51 6.51 0 00-1.68 1.33l.06 3.33z"
          fill="#8e0000"
        />
        <path
          className="cls-3"
          d="M83.47 68.86a1.47 1.47 0 11-1.65-1.26 1.47 1.47 0 011.65 1.26z"
        />
        <path
          className="cls-5"
          d="M99 78.33l.12-.24a2.46 2.46 0 01-1.29-1.55c.15.49-.1 0-.26-.19s-.3-.31-.45-.47c-.34-.33-.71-.62-1.08-.93l-.56-.47c-2-.85-4-1.66-6-2.47l-8.31 43.58 2 .68c.3-.84 4.6-8.1 6.29-12.24a16.14 16.14 0 001-5.82A20.17 20.17 0 0194.08 87 72.42 72.42 0 0099 78.33z"
        />
        <path
          className="cls-6"
          d="M82.1 116.84l1.18-.16c.48-.37.11-1.54.11-1.54s-4.56-1-5-.89a1 1 0 00-.64.9c.1.32 3.54 1.74 4.35 1.69z"
        />
        <path
          className="cls-7"
          d="M82.15 115.55a6.81 6.81 0 001.36-.06 1.4 1.4 0 010-.48s-1.9-.25-3.33-.52a2.53 2.53 0 001.97 1.06z"
        />
        <path
          className="cls-3"
          d="M100.68 71.89a1.86 1.86 0 00-.1-.25 2.45 2.45 0 01-2-.12c.47.23-.08.07-.31.07h-.65c-.48 0-1 .09-1.42.15l-.73.09c-2 .88-3.94 1.8-5.9 2.73l26.26 35.75 1.85-1c-.41-.8-2.8-8.89-4.69-12.95a16.46 16.46 0 00-3.56-4.71 20.12 20.12 0 01-5.76-10.31 72.47 72.47 0 00-2.99-9.45z"
        />
        <path
          className="cls-7"
          d="M116.78 109.79a7.16 7.16 0 00.58-1.24 1.32 1.32 0 01-.42-.27s-1.09 1.58-2 2.72a2.55 2.55 0 001.84-1.21z"
        />
        <path
          className="cls-6"
          d="M116.05 112.34a9.09 9.09 0 001.85-1.91l.41-1.13c-.1-.6-1.31-.81-1.31-.81s-3 3.59-3.09 4a.58.58 0 000 .19z"
        />
        <path
          className="cls-6"
          d="M115 111a7.41 7.41 0 01-1.39.7c-.45.12-.51.56-.45 1a13.72 13.72 0 002.3-.34c.31-.16 1.2-.76 1.07-.93A6.77 6.77 0 00115 111z"
        />
        <path
          className="cls-8"
          d="M90.18 63.25a62 62 0 01-.34 6.32l-3.55 16.89s16.16.05 21.14-1.79c-.91-2.53-4.59-14.16-6.87-17s-1.68-3-3.48-5.1-2.93-1.36-2.93-1.36z"
        />
        <path
          className="cls-3"
          d="M92.63 41a10.15 10.15 0 00.88 5.62c.42 1.93-2.75 7.1-3.64 7.27a10.28 10.28 0 010-6.26A11.74 11.74 0 0088.55 42a8.94 8.94 0 012-1.31c.26-.07 2.08.31 2.08.31z"
        />
        <path
          className="cls-3"
          d="M90.74 67.14s-.48-4-1.2-7-1-3.48-1.77-4.38a7.06 7.06 0 01-1.08-1.45 7.43 7.43 0 01.37-3.88c.74-2 1.82-3.43 3.43-3.65s4-.51 5.28.85S97.7 53 97 55.24 94.65 62 97.62 66a9.73 9.73 0 01-6.88 1.14z"
        />
        <path
          className="cls-8"
          d="M97 55.24c.71-2.21.09-6.3-1.22-7.65A2.85 2.85 0 0095 47a5.82 5.82 0 01-4 2.17c-2.19.3-2.59-.6-2.64-1.14a8.37 8.37 0 00-1.28 2.34 7.43 7.43 0 00-.37 3.88 7.06 7.06 0 001.08 1.45c.74.9 1 1.32 1.77 4.38s1.2 7 1.2 7A9.73 9.73 0 0097.62 66c-2.97-4-1.34-8.56-.62-10.76z"
        />
        <path
          className="cls-3"
          d="M93.38 41s-1 4.63-4.61 4-3.37-10.39-1.52-12.26 7.08 4.63 7.08 4.63zM112.34 61.92A30.81 30.81 0 01102 54.15c-.21-.38-3-4-3.36-4.32a23.74 23.74 0 00-3.13-1.4 4.4 4.4 0 01-.38 1l-.13.47v.1c0 .03-.07.19-.11.29v.07a.38.38 0 000 .1c.63 1.28 4.8 5.92 4.8 5.91 6.74 7.33 12.66 7.23 13.29 7.25.19-.62.02-1.16-.64-1.7z"
        />
        <path
          className="cls-3"
          d="M112.68 64.15a.57.57 0 00-.42-.72.67.67 0 00-.94.59c-.09.69.84 1.84 1.19.72a4.36 4.36 0 00.17-.59z"
        />
        <path
          className="cls-8"
          d="M95 47a9.36 9.36 0 014.7 4.4c-.91.6-4.84 3.35-4.84 3.35a1.59 1.59 0 01-1.28-1.7c0-1.5-.07-2.45-.07-2.45a5.34 5.34 0 01.87-2.06c.62-.62.35-1.49.62-1.54z"
        />
        <path
          className="cls-3"
          d="M113.62 64.5a3.38 3.38 0 00-.67-.4c-.69-.31-1.75-.45-1.4-1.48.6-1.83 4.51-.24 4.24 1.47a2.06 2.06 0 01-.32 1 .4.4 0 01-.58 0c-.26-.21-1.01-.39-1.27-.59z"
        />
        <path
          className="cls-3"
          d="M112.11 65.07a4.11 4.11 0 012-2.44 1.11 1.11 0 01.32 2.19c-.65.09-2.28.86-2.32.25z"
        />
        <path
          className="cls-9"
          d="M84.22 32.2c.3-1 2.54-2.83 6-3.28a10.23 10.23 0 016.56 1.34c1.65.78 3.48.46 5.3-.19a12.55 12.55 0 018.12 0c2.8 1.17 4.56 2.05 6.2 2.52 2.74.78 3.52 3.88 2 6.37s-5.16 3.26-8.37 1.74c-2.65-1.26-5.68-.18-8 1.14-3.87 2.17-7.52 2.35-9.8-.61-.53-.69-.92-2.28-.36-2.78a1.27 1.27 0 00.12-2c-.84-.66-1.57.62-1.85.37a3.43 3.43 0 00-2.58-1c-1.84-.17-3.73-2.31-3.34-3.62z"
        />
      </g>
      <path
        className="cls-10"
        d="M40.47 76.28c.34 4.65 22.31 18.35 22.44 18.72q.09.26-6.84 16.2l1.93.8q10.61-16.92 10.07-18.72-.78-2.58-17-17z"
      />
      <path
        d="M56.58 108.82l3.13 1.18c6.61-7.46 9.21-13.61 8.73-16.75q-.47-3.13-17-16.92H40.25c.38 10.78 20.74 18.77 21 19.23s-2.39 4.92-4.67 13.26z"
        fill="url(#linear-gradient-2)"
        fillRule="evenodd"
      />
      <path
        className="cls-12"
        d="M55.37 110.86a3.82 3.82 0 00-.74 1.08 10.9 10.9 0 00-.35 1.46l10 3.65c.57-.77.59-1.29 0-1.56l-1.33-.7-3.82-3.79a.19.19 0 00-.27 0l-.56.62a3.41 3.41 0 01-1.4-.1 3.14 3.14 0 01-1-.72.38.38 0 00-.54 0z"
      />
      <path
        className="cls-10"
        d="M43 76.28l-9.79 23.49-9.62 19.86h2.27l24.83-43.35H43z"
      />
      <path
        className="cls-12"
        d="M23.46 118.72a4.07 4.07 0 00-.32 1.26 10.1 10.1 0 00.17 1.5H34c.28-.92.12-1.42-.48-1.49s-1.09-.14-1.49-.2l-5-2.21a.19.19 0 00-.25.1l-.32.78a3.32 3.32 0 01-1.34.38 3 3 0 01-1.12-.34.39.39 0 00-.5.19z"
      />
      <path
        d="M24.46 115.51l5.05.94c3.89-5.73 20.21-29.23 22-40.17H40.28c-5.97 7.91-12.1 33.4-15.82 39.23z"
        fill="url(#linear-gradient-3)"
        fillRule="evenodd"
      />
      <path
        d="M62.73 58.6c-.53.94-1 1.95-.78 2.24s.95-.11 1.27.37c.21.32-.94.83-3.45 1.52L55 67.1l-2.42-2.61 6.56-3.59a16.16 16.16 0 013.23-3c.32-.16.89-.24.36.7zm5 6.6c.82-.17 2.82-1.66 3.16-1.36.51.45.06 1.82-.48 2.5-1 1.28-1.83 1.71-3.87 2.29A11 11 0 0063 70.42l-.16-2.89 2.88-1.59c.41-1.54.89-2.31 1.45-2.32.45-.2-.3 1.74.52 1.58z"
        fillRule="evenodd"
        fill="#f6a18a"
      />
      <path
        d="M49.38 63.69A16.16 16.16 0 0058 61.11L59.3 64c-2.26 2.24-5.43 4.08-8.2 4a2.5 2.5 0 01-1.72-4.31z"
        fillRule="evenodd"
        fill="#a40600"
      />
      <path
        d="M48.54 56.68c.05.68 1.15 1 1.38 1.53 1.06 2.72.9 5.4 1.87 8.71 2.45.61 6 1.08 11.74-1 1.43 3 1.49 2.72 1.38 4a23.29 23.29 0 01-11.66 2.93c.11 2.06.71 7.42-.14 9.21-1.73 3.7-18.61 1.19-16.68-1.71 2.83-4.25 3-15.15 4.36-20.88.71-3.08 3.18-3.09 3.32-3.31z"
        fill="#e00e0e"
        fillRule="evenodd"
      />
      <path
        className="cls-5"
        d="M48.58 56.08V51.5l-4.46-2v6.65S45 59.32 46.91 59s1.67-2.92 1.67-2.92z"
      />
      <path
        className="cls-5"
        d="M49.78 54.94l.53-.18a3.51 3.51 0 002.13-4.45l-1.51-4.45a3.5 3.5 0 00-4.4-2.24l-.53.18a3.51 3.51 0 00-2.13 4.45l1.51 4.45a3.5 3.5 0 004.4 2.24z"
      />
      <path
        className="cls-5"
        d="M43 51.49a1.21 1.21 0 10.72-1.64 1.26 1.26 0 00-.72 1.64z"
      />
      <path
        className="cls-9"
        d="M52 48.11a24.34 24.34 0 011.16 3.6 3.62 3.62 0 01-.44 3.07 4.61 4.61 0 01-2.94 1.34 6.89 6.89 0 01-1.92 0 3.39 3.39 0 01-2.31-1.31l-.12-.18a5.6 5.6 0 01-.58-1.21l-1-3 1.1-.37.13.39a2.66 2.66 0 00.64 1.07 2.79 2.79 0 001.74.72 6.56 6.56 0 002.75-.65A2.25 2.25 0 0051.94 50c.31-.76-.94-4.15-2-5.63-.45-.59.16-.76.27-.61A21.58 21.58 0 0152 48.11z"
      />
      <path
        className="cls-9"
        d="M45.2 45.54a2.78 2.78 0 012.14-.54A3.93 3.93 0 0051 43.76c1-1.33-.27-5-2.66-5.49-1.9-.4-2.76.58-4.23 1.82-1.76 1.47-2.08 2.34-2 3.14.08.52-.56.41-1.1.77a3.2 3.2 0 00-.01 4.52 5.08 5.08 0 002.15 1.82s.16-.29.37-.35.3.43.3.43l1.11-.37-.7-2c-.15-.44.06-.7.16-1.15a2.38 2.38 0 01.81-1.36z"
      />
      <path
        className="cls-8"
        d="M45.2 110.88c-3.67-10.83-7.72-14.62-12.41-19-1.46-1.37-3-2.79-4.57-4.5l.16-.15c1.59 1.7 3.1 3.12 4.56 4.49 4.71 4.42 8.78 8.23 12.47 19.11z"
      />
      <path
        className="cls-8"
        d="M25.83 86.91a6.46 6.46 0 01-2.06-4 1.53 1.53 0 01.43-1.39c.62-.46 1.7.06 2.29.54 2.42 2 2.89 4.4 3.66 7a8.1 8.1 0 01-4.32-2.15zm8 5.73c1.33-1.82 2.66-3.34 2.73-5.9 0-.63-.19-1.59-.79-1.76a1.23 1.23 0 00-1.12.42 5.26 5.26 0 00-1.58 3.36 6.6 6.6 0 00.79 3.88zm5.53 6.44c1.82-1.58 3.57-2.85 4.26-5.5.17-.66.19-1.71-.4-2a1.36 1.36 0 00-1.27.17 5.7 5.7 0 00-2.46 3.13 7.1 7.1 0 00-.1 4.2zm2.6 4.2c1.83-1.58 3.58-2.84 4.27-5.5.17-.65.18-1.7-.41-2a1.33 1.33 0 00-1.27.16 5.68 5.68 0 00-2.45 3.13 7.05 7.05 0 00-.1 4.21zM30.41 90.4a5.78 5.78 0 00-3.11-.47c-.67.12-1.38.51-1.37 1.28a1.22 1.22 0 00.31.79 2.74 2.74 0 001.68.82 13.27 13.27 0 005.65-.5 21.74 21.74 0 00-3.16-1.92zm9.35 9a13.63 13.63 0 00-3.06-1.69 5.77 5.77 0 00-3.11-.47 1.63 1.63 0 00-1.32.92 1.35 1.35 0 00.5 1.39 3.39 3.39 0 001.44.59 13.27 13.27 0 005.65-.51zm-3-3.84a13.4 13.4 0 00-3.16-1.46 5.84 5.84 0 00-3.15-.2 1.59 1.59 0 00-1.23 1 1.34 1.34 0 00.62 1.34 3.18 3.18 0 001.48.46 13.2 13.2 0 005.59-1zm5.17 7.44a13.59 13.59 0 00-3.19-1.41 5.75 5.75 0 00-3.15-.21 1.62 1.62 0 00-1.23 1 1.35 1.35 0 00.62 1.34 3.33 3.33 0 001.49.45 13.33 13.33 0 005.58-1zm1.84 4a13.78 13.78 0 00-3.19-1.41 5.75 5.75 0 00-3.15-.21 1.62 1.62 0 00-1.23 1 1.35 1.35 0 00.62 1.34 3.43 3.43 0 001.49.46 13.5 13.5 0 005.58-1zm-4.38-15a6.43 6.43 0 001.18-1.66 1.9 1.9 0 00-.16-2 1.6 1.6 0 00-1.63-.4 2.44 2.44 0 00-1.33 1.12 5.59 5.59 0 00-.6 1.66 15.19 15.19 0 00-.24 4.94S38.5 93 39.39 92zm9.18 10.87c-.69 2.66-2.44 3.92-4.26 5.5a7.1 7.1 0 01.13-4.23A5.7 5.7 0 0146.9 101a1.34 1.34 0 011.26-.17c.6.31.58 1.37.41 2.02zm-.45-.78a.31.31 0 00-.44-.09l-.1.09a.56.56 0 00-.16.28.64.64 0 00-.07.41.33.33 0 00.53.24.5.5 0 00.2-.27.9.9 0 00.04-.68z"
      />
      <path
        className="cls-17"
        d="M96.65 107.35c12.08-8.55 20.08-18.26 22.52-27.35l.21.06c-2.45 9.14-10.48 18.9-22.61 27.48z"
      />
      <path
        className="cls-17"
        d="M110.06 86.88l.21-.07a33.74 33.74 0 011.69 6.6 58.64 58.64 0 017.83-4.28l.08.2a61.65 61.65 0 00-7.94 4.35l-.15.1v-.18a32.22 32.22 0 00-1.72-6.72zM116.29 77.5a11.46 11.46 0 014.17-6.87A2.71 2.71 0 01123 70c1.27.5 1.49 2.61 1.31 4-.74 5.5-4 8.46-7.22 12.07a14.27 14.27 0 01-.8-8.57z"
      />
      <path
        className="cls-17"
        d="M122 86.06a11.54 11.54 0 018-.45 2.7 2.7 0 011.93 1.71c.31 1.32-1.31 2.7-2.52 3.31-5 2.5-9.22 1.52-14.05.87a14.32 14.32 0 016.64-5.44zM106 95.3h.21l.79 3.4a16.75 16.75 0 016.27-2.06 3.49 3.49 0 00.76-.15l.14.18a2.88 2.88 0 01-.86.19A16.35 16.35 0 00107 99l-.13.09z"
      />
      <path
        className="cls-17"
        d="M107.05 89.47a11.77 11.77 0 00-2.09-6 3.27 3.27 0 00-2.89-1.47 2.71 2.71 0 00-2 2.2 6.69 6.69 0 00.32 3.13c1.06 3.63 3.73 6.79 6.24 9.61a43.17 43.17 0 00.42-7.47zM109.8 97.66a30.39 30.39 0 019.52-3 11 11 0 013.58 0 5 5 0 013 1.72 3.23 3.23 0 01.4 3.38 3.85 3.85 0 01-3.65 1.7 13 13 0 01-4-1c-2.47-1.13-8.85-2.8-8.85-2.8zM100.99 104.43l-.58-3.77.22-.04.54 3.57 4.47-.51.03.22-4.68.53z"
      />
      <path
        className="cls-17"
        d="M111.3 102.19a11.47 11.47 0 017.37 3.19 2.7 2.7 0 011 2.39c-.32 1.32-2.38 1.83-3.74 1.84-5.55 0-8.93-2.76-13-5.5a14.25 14.25 0 018.37-1.92zM102.12 96.76a9.67 9.67 0 00-.88-5.19A2.7 2.7 0 0099.08 90a2.26 2.26 0 00-2 1.52 5.56 5.56 0 00-.17 2.6c.37 3.11 2.12 6 3.77 8.71a35.52 35.52 0 001.44-6.07zM106.45 78.14a6.54 6.54 0 000 3.14c.63 3.73 2.93 7.17 5.09 10.26a43.85 43.85 0 001.3-7.35A11.74 11.74 0 00111.4 78a3.24 3.24 0 00-2.7-1.8 2.71 2.71 0 00-2.25 1.94zM44.31 111l-.2-.09c3.73-8.34 9.52-16.6 14.42-20.55l.14.17C53.8 94.5 48 102.73 44.31 111z"
      />
      <path
        className="cls-17"
        d="M60.7 94a25.82 25.82 0 00-5.4-.23v-.21a24.71 24.71 0 015.45.23zM53.57 95.82l-.2-.08a47.43 47.43 0 002.18-6.89h.22a47.65 47.65 0 01-2.2 6.97zM64.42 86.29A11.33 11.33 0 0067.16 80a1.92 1.92 0 00-.61-1.86c-.84-.49-2.3.52-3.1 1.37-3.26 3.44-4.18 7.26-5.17 11.2a15.57 15.57 0 006.14-4.42z"
      />
      <path
        className="cls-17"
        d="M57.78 86.76a8.7 8.7 0 00-.94-6.15 2.16 2.16 0 00-1.63-1.21c-1.08 0-1.89 1.42-2.17 2.44-1.14 4.15.29 7.22 1.58 10.79a11.08 11.08 0 003.16-5.87z"
      />
      <path
        className="cls-17"
        transform="rotate(-89 53.869 97.043)"
        d="M53.77 95.67h.22v2.76h-.22z"
      />
      <path
        className="cls-17"
        d="M50.34 100.21l-.21-.08a12.32 12.32 0 00.63-5.13 2.05 2.05 0 010-.69l.2.09h-.1.1a4.07 4.07 0 00.04.6 12.46 12.46 0 01-.66 5.21zM59.61 95.46a9.33 9.33 0 015 .65 2.52 2.52 0 011.61 2 2.1 2.1 0 01-1.39 1.87 5.42 5.42 0 01-2.47.25c-3-.24-5.87-1.77-8.47-3.23a34.83 34.83 0 015.72-1.54z"
      />
      <path
        className="cls-17"
        d="M50.73 97.81a23.08 23.08 0 00.83-7.71 8.17 8.17 0 00-.56-2.72 3.77 3.77 0 00-1.83-2 2.58 2.58 0 00-2.68.22 3 3 0 00-.74 3 10 10 0 001.46 2.85c1.19 1.77 3.52 6.36 3.52 6.36z"
      />
      <path
        className="cls-17"
        transform="rotate(-2.91 47.502 107.377)"
        d="M45.94 107.23h3.16v.22h-3.16z"
      />
      <path
        className="cls-17"
        transform="rotate(-5.4 46.854 103.795)"
        d="M46.68 101.9h.22v3.57h-.22z"
      />
      <path
        className="cls-17"
        d="M47 97.38a8.92 8.92 0 00-3.66-5.1 2.18 2.18 0 00-2-.36c-1 .45-1 2.09-.83 3.12.88 4.21 3.57 6.34 6.35 9a10.83 10.83 0 00.14-6.66zM51.86 105.43a7.93 7.93 0 014.18-.14 2.12 2.12 0 011.59 1.39 1.73 1.73 0 01-.87 1.71 4.28 4.28 0 01-2 .53c-2.47.21-5-.65-7.36-1.49a29 29 0 014.46-2z"
      />
      <path
        className="cls-17"
        transform="rotate(-2.58 50.116 102.652)"
        d="M48.53 102.7h3.35v.22h-3.35z"
      />
      <path
        className="cls-17"
        d="M55 100.91a10.23 10.23 0 014.76-.14c.81.21 1.64.67 1.81 1.38a1.67 1.67 0 01-1 1.72 5.73 5.73 0 01-2.27.53c-2.82.21-5.74-.65-8.4-1.5a36.26 36.26 0 015.1-1.99zM69.11 91.39a2.38 2.38 0 00-2-1.47 9.47 9.47 0 00-5 .69 37 37 0 00-5.24 3c2.84.73 6 1.45 8.94.89a5.39 5.39 0 002.36-.89 2.2 2.2 0 00.94-2.22z"
      />
    </g>
  </svg>
);
